import React from "react";

export const ProductTileSkeleton = () => {
  return (
    <div className="collection-tile skeleton" aria-hidden="true">
      <div className="skeleton-container" />
      <div className="w-40 h-6 bg-[#e9e9e9]" />
      <div className="flex justify-between mt-[16px] flex-col lg:flex-row gap-4">
        <div className="w-full">
          <div className="w-full h-6 bg-[#e9e9e9]" />
          <div className="w-full h-4 mt-1 bg-[#e9e9e9]" />
        </div>
        <div className="w-full h-6 bg-[#e9e9e9]" />
      </div>
      <div className="w-full h-5 mt-4 bg-[#e9e9e9]" />
    </div>
  );
};

export default ProductTileSkeleton;
